import React from 'react';
import {
  FormGroup, Modal, ModalBody, Label, Input, ModalFooter,
} from 'reactstrap';
import PropTypes from 'prop-types';
import vapi from '../javascript/frontend/api/vapi';
import vahoy from '../javascript/vahoy';

function Select2AddPublicationModal(props) {
  const {
    showModal, modalTitle, placeHolderText, labelText, onSelect, onHide,
  } = props;

  // eslint-disable-next-line react/destructuring-assignment
  const [searchingTerm, setSearchingTerm] = React.useState(props.searchingTerm);

  // eslint-disable-next-line react/destructuring-assignment
  const [publications, setPublications] = React.useState(props.publications || []);

  React.useEffect(() => {
    if (searchingTerm && showModal) {
      const loadCompanies = async () => {
        const params = {
          'filter[name]': searchingTerm,
          'page[offset]': 0,
          'page[limit]': 2,
        };

        const response = await vapi.searchPublications(params);
        if (response.status === 200) {
          const responseData = response.data;
          if (responseData.data) {
            setPublications(responseData.data);
          }
        }
      };

      loadCompanies();
    }
  }, [searchingTerm, showModal]);

  React.useEffect(() => {
    // eslint-disable-next-line react/destructuring-assignment
    setSearchingTerm(props.searchingTerm);
    // eslint-disable-next-line react/destructuring-assignment
  }, [props.searchingTerm]);

  const selectPublication = (publication) => {
    onSelect && onSelect(publication.id, publication.attributes.name, publication);
    vahoy.track('Select2AddPublicationModal#selectPublication');
  };

  const addNewPublication = () => {
    onSelect && onSelect('new', searchingTerm);
    vahoy.track('Select2AddPublicationModal#addNewPublication');
  };

  return (
    <Modal
      id="add_publication_modal"
      className="modal-lg select2-add-publication-modal"
      isOpen={showModal}
      toggle={onHide}
    >
      <ModalBody>
        <div className="d-flex justify-content-between">
          <div className="flex-grow-1">
            <div className="h3 mt-2 fw-bold mb-3 mb-4 pb-1">{modalTitle || 'Add new publication'}</div>
            <div className="pe-4 me-3">
              <form>
                <FormGroup>
                  <Label for="searchPublicationName">{labelText}</Label>
                  <Input
                    id="searchPublicationName"
                    type="text"
                    value={searchingTerm || ''}
                    placeholder={placeHolderText || 'New Publication Name'}
                    name="term"
                    onChange={(evt) => setSearchingTerm(evt.target.value)}
                  />
                </FormGroup>
              </form>
              {publications && publications.length > 0
                && (
                  <div className="publications-container">
                    <div className="mb-2">Did you mean?</div>
                    <div className="ps-5 ms-3">
                      {publications.map((publication) => (
                        <div
                          key={publication.id}
                          className="publication d-flex cursor-pointer"
                          role="button"
                          tabIndex={-1}
                          onClick={() => selectPublication(publication)}
                          onKeyPress={(evt) => evt.key == 'enter' && selectPublication(publication)}
                        >
                          <div className="publication-image">
                            <img src={publication.attributes.image_cloudinary_url} alt="" style={{ maxWidth: '100px' }} />
                          </div>
                          <div className="publication-name">
                            {publication.attributes.name}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              <div className="clearfix" />
            </div>
          </div>

          <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="text-end pe-4 me-3">
          <button type="button" className="btn btn-primary pe-5 ps-5" onClick={() => addNewPublication()}>
            {modalTitle}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

Select2AddPublicationModal.propTypes = {
  showModal: PropTypes.bool,
  modalTitle: PropTypes.string,
  placeHolderText: PropTypes.string,
  labelText: PropTypes.string,
  searchingTerm: PropTypes.string,
  publications: PropTypes.arrayOf(PropTypes.object),
  onHide: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
};

Select2AddPublicationModal.defaultProps = {
  showModal: undefined,
  modalTitle: undefined,
  placeHolderText: undefined,
  labelText: undefined,
  searchingTerm: undefined,
  publications: [],
  onSelect: undefined,
};

export default Select2AddPublicationModal;
